import {
  CollateralResponseSchema,
  PositionResponseSchema,
} from '@lyra/core/api/types/private.get_subaccount'

export type Position = PositionResponseSchema
export type ActiveCollateralPosition = CollateralResponseSchema

// Position warning at spot price within 5% of liquidation price
export const SPOT_WARNING_THRESHOLD = 0.05
// Position is critical at spot price within 1% of liquidation price
export const SPOT_CRITICAL_THRESHOLD = 0.01

// Margin utilization warning, 5% away from liquidation
export const MARGIN_UTIL_WARNING_THRESHOLD = 0.95
// Margin utilization is critical, 1% away from liquidation
export const MARGIN_UTIL_CRITICAL_THRESHOLD = 0.99
